import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotesEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "notes-edit" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M22.63,14.862,15,22.492l-3.75.75.75-3.75,7.63-7.63a2.116,2.116,0,0,1,2.992,0l.008.009A2.113,2.113,0,0,1,22.63,14.862Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.25,20.242h-6a1.464,1.464,0,0,1-1.5-1.5V3.849a1.557,1.557,0,0,1,1.5-1.607h15a1.557,1.557,0,0,1,1.5,1.607V8.242"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 5.25,
			y1: .742,
			x2: 5.25,
			y2: 5.242
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 9.75,
			y1: .742,
			x2: 9.75,
			y2: 5.242
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 14.25,
			y1: .742,
			x2: 14.25,
			y2: 5.242
		})
	]
});
export default SvgNotesEdit;
